<template>
    <span>
        <v-container class="alingCenter" fluid style="padding-top: 80px;padding-left: 130px" >
            <v-flex lg-12 class="row pt-3">
                 <v-card-text class="display-1 font-weight-thin">MI PERFIL</v-card-text>
            </v-flex>
            <v-flex lg-12 class="row pb-3" style="margin-top: -20px">
                <v-card-text>Mantén tu información actualizada.</v-card-text>
              </v-flex>

        </v-container>
        <v-container fluid style="padding-top: 10px;padding-left: 130px" class="grey lighten-4 paddingLeft">
            <personal-data style="margin-top: -30px"></personal-data>
            <payment-data style="margin-top: 15px"></payment-data>
        </v-container>
    </span>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'

    import personalData from './persona_data.vue'
    import paymentData from './payment_data.vue'
    export default {
        name: 'generalSetting',
        components: {
            personalData,
            paymentData,
        },
        created(){

        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style>
    @media screen and (max-width: 768px) {
        .paddingLeft{
            padding-left: 30px!important;
        }
        .alingCenter{
            text-align: center;
            margin-left: -300px;
        }
    }
</style>
